/* Structured data is derived from the product FAQs that are actually rendered. */
(() => {
  if (window.sgProductFaqSchema) return;
  window.sgProductFaqSchema = true;
  const schemaId = 'sg-product-faq-jsonld';
  const hasFaq = (value) => {
    if (!value || typeof value !== 'object') return false;
    if ([].concat(value['@type'] || []).includes('FAQPage')) return true;
    return Object.values(value).some((entry) => Array.isArray(entry) ? entry.some(hasFaq) : hasFaq(entry));
  };
  const readable = (element) => {
    if (!element) return '';
    const copy = element.cloneNode(true);
    copy.querySelectorAll('script,style,svg,[aria-hidden="true"]').forEach((node) => node.remove());
    copy.querySelectorAll('br,p,li,div').forEach((node) => node.append(' '));
    return copy.textContent.replace(/\s+/g, ' ').trim();
  };
  const hiddenSection = (element) => {
    for (let node = element; node && node.id !== 'MainContent'; node = node.parentElement) {
      if (node.hidden || node.getAttribute('aria-hidden') === 'true') return true;
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return true;
    }
    return false;
  };
  const refresh = () => {
    let own = document.getElementById(schemaId);
    for (const script of document.querySelectorAll('script[type="application/ld+json"]')) {
      if (script === own) continue;
      try { if (hasFaq(JSON.parse(script.textContent))) { own?.remove(); return; } } catch (_) { /* Unrelated malformed app data. */ }
    }
    const main = document.getElementById('MainContent');
    if (!main) return;
    const questions = [];
    const seen = new Set();
    const add = (question, answer, container) => {
      if (hiddenSection(container)) return;
      const name = readable(question), text = readable(answer);
      const key = name + '\n' + text;
      if (!name || !text || seen.has(key)) return;
      seen.add(key);
      questions.push({'@type':'Question', name, acceptedAnswer:{'@type':'Answer',text}});
    };
    main.querySelectorAll('.fragen-zu-spider-26__item').forEach((item) => {
      add(item.querySelector('.fragen-zu-spider-26__question-text'), item.querySelector('.fragen-zu-spider-26__answer-inner'), item);
    });
    main.querySelectorAll('.sg-accessory__faq details, .sg-growbox-faq details, .sg-soil-details__faq details, .sg-b2-faq details').forEach((item) => {
      const summary = item.querySelector('summary');
      const answer = item.cloneNode(true); answer.querySelector('summary')?.remove();
      add(summary, answer, item);
    });
    main.querySelectorAll('.brands-faqs .bfaqs .faq-box').forEach((item) => {
      add(item.querySelector('.faq h2'), item.querySelector('.ets-box'), item);
    });
    if (!questions.length) { own?.remove(); return; }
    if (!own) { own = document.createElement('script'); own.type='application/ld+json'; own.id=schemaId; document.head.append(own); }
    const url = document.querySelector('link[rel="canonical"]')?.href || location.origin + location.pathname;
    own.textContent=JSON.stringify({'@context':'https://schema.org','@type':'FAQPage','@id':url+'#faq',mainEntity:questions});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once:true});
  else refresh();
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',refresh);
})();
